import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { SessionService } from 'src/app/services/storage/session.service';

import { AgentPaths, BasePaths, MemberPaths } from 'src/app/constants/routes';
import { ApiService } from '../services/api.service';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private router: Router,
        private apiService: ApiService,
    ) {
    }

    public canActivate(): Observable<boolean> {
        if (this.sessionService.session.isVersionIncompatible) {
            this.router.navigateByUrl(BasePaths.VersionError);
            this.apiService.cancelTimer();
        } else if (this.sessionService.session.isLoggedIn) {
            if (this.sessionService.session.isMember)
                this.router.navigateByUrl(MemberPaths.Dashboard);
            else
                this.router.navigateByUrl(AgentPaths.CounselorMemberLookup);
        }

        return of(!this.sessionService.session.isVersionIncompatible);
    }
}